import { cn } from '@/lib/utils'

interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'default' | 'lg' | 'xl'
}

const containerSizes = {
  sm: 'max-w-2xl',
  md: 'max-w-4xl',
  default: 'max-w-6xl',
  lg: 'max-w-7xl',
  xl: 'max-w-[1400px]',
}

export function Container({
  className,
  size = 'xl',
  ...props
}: ContainerProps) {
  return (
    <div
      className={cn(
        'mx-auto px-4 sm:px-6 lg:px-8',
        containerSizes[size],
        className
      )}
      {...props}
    />
  )
}
